import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'semantic-ui-react';

export const handleCreateCategory = (isIncome, setCreateCategory, setCreateIncomeCategory) => {
  setCreateCategory(true);
  setCreateIncomeCategory(isIncome);
};

const CreateCategoryModal = ({
  createIncomeCategory,
  incomeAreas,
  expenseAreas,
  onFormChange = () => {},
}) => {
  const { t } = useTranslation('finance');
  const [categoryName, setCategoryName] = useState('');
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [filterText, setFilterText] = useState('');

  React.useEffect(() => {
    setCategoryName('');
    setSelectedAreas([]);
    setFilterText('');
  }, [createIncomeCategory]);

  React.useEffect(() => {
    onFormChange({
      categoryName,
      selectedAreas,
    });
  }, [categoryName, selectedAreas, onFormChange]);

  const typeKey = createIncomeCategory ? 'income' : 'expense';

  return (
    <div className="tw-space-y-6">
      <div className="tw-flex tw-items-center tw-gap-3 tw-pb-4 tw-border-b tw-border-gray-200">
        <div className={`tw-p-2 tw-rounded-lg ${createIncomeCategory ? 'tw-bg-green-100' : 'tw-bg-red-100'}`}>
          <Icon name="chart area" color={createIncomeCategory ? 'green' : 'red'} size="large" />
        </div>
        <div>
          <h3 className="tw-text-lg tw-font-semibold tw-text-gray-900">
            {t(`categoryModals.${typeKey}`)}
          </h3>
          <p className="tw-text-sm tw-text-gray-600">
            {t(`categoryModals.createCategorySubtitle${createIncomeCategory ? 'Income' : 'Expense'}`)}
          </p>
        </div>
      </div>

      <div className="tw-space-y-2">
        <label className="tw-block tw-text-sm tw-font-medium tw-text-gray-700">
          {t('categoryModals.categoryName')} <span className="tw-text-red-500">*</span>
        </label>
        <input
          type="text"
          placeholder={t('categoryModals.categoryNamePlaceholder')}
          value={categoryName}
          className="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent tw-text-base"
          onChange={(e) => setCategoryName(e.target.value)}
        />
        <p className="tw-text-xs tw-text-gray-500">{t('categoryModals.categoryNameHint')}</p>
      </div>

      <div className="tw-space-y-3">
        <div className="tw-flex tw-items-center tw-gap-2">
          <Icon name="settings" color="blue" />
          <h4 className="tw-text-sm tw-font-medium tw-text-gray-700">
            {t('categoryModals.assignExistingAreas')}
          </h4>
        </div>
        <p className="tw-text-sm tw-text-gray-600">{t('categoryModals.assignAreasHint')}</p>

        <div className="tw-relative">
          <input
            type="text"
            placeholder={t('categoryModals.searchAreas')}
            value={filterText}
            className="tw-w-full tw-pl-10 tw-pr-3 tw-py-2 tw-border tw-border-gray-300 tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-border-transparent"
            onChange={(e) => setFilterText(e.target.value)}
          />
          <Icon
            name="search"
            className="tw-absolute tw-left-3 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-text-gray-400"
          />
        </div>

        <div className="tw-max-h-48 tw-overflow-y-auto tw-border tw-border-gray-200 tw-rounded-lg">
          {(createIncomeCategory ? incomeAreas : expenseAreas)
            ?.filter((area) => area.label.toLowerCase().includes(filterText.toLowerCase()))
            ?.map((area) => (
              <div
                key={area.cashflowAreaId}
                className="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-border-b tw-border-gray-100 hover:tw-bg-gray-50"
              >
                <input
                  type="checkbox"
                  id={`area-${area.cashflowAreaId}`}
                  checked={selectedAreas.some((sa) => sa.cashflowAreaId === area.cashflowAreaId)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedAreas([...selectedAreas, area]);
                    } else {
                      setSelectedAreas(selectedAreas.filter((sa) => sa.cashflowAreaId !== area.cashflowAreaId));
                    }
                  }}
                  className="tw-w-4 tw-h-4 tw-text-blue-600 tw-border-gray-300 tw-rounded focus:tw-ring-blue-500"
                />
                <label
                  htmlFor={`area-${area.cashflowAreaId}`}
                  className="tw-text-sm tw-text-gray-700 tw-cursor-pointer tw-flex-1"
                >
                  {area.label}
                </label>
              </div>
            ))}
          {(createIncomeCategory ? incomeAreas : expenseAreas)?.length === 0 && (
            <div className="tw-p-4 tw-text-center tw-text-gray-500">
              {t('categoryModals.noAreasAvailable')}
            </div>
          )}
        </div>
      </div>

      {selectedAreas.length > 0 && (
        <div className="tw-bg-blue-50 tw-p-3 tw-rounded-lg">
          <p className="tw-text-sm tw-text-blue-700">
            <Icon name="check circle" color="blue" />
            {t('categoryModals.areasSelected', { count: selectedAreas.length })}
          </p>
        </div>
      )}
    </div>
  );
};

export default CreateCategoryModal;
